module.exports = __webpack_public_path__ + "assets/img/wall-cases.4212fad3.svg";